<template>
  <span class="label" :style="{ backgroundColor: color }">{{ text }}</span>
</template>
 
<script>
import { purposeTopic } from '../data'
 
export default {
  name: 'topic-label',
  props: {
    target: {
      type: String,
      require: true,
      default:''
    }
  },
  computed: {
    text: function() {
      var self=this;
      var result = purposeTopic.find(obj => {
        return obj.label === self.target
      })
      if(result)
       return result.label;
       else return '';
    },
    color: function() {
      var self=this;
       var result = purposeTopic.find(obj => {
        return obj.label === self.target
      })
      
       if(result)
       return result.color;
       else return '';
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/plugins/SearchPlugin/components/TopicLabel.vue